define('meetings/upcoming-meetings/upcoming-meetings',['require','exports','module','durandal/app','knockout','plugins/router','lodash','../../scheduler/scheduler-container','moment','i18next','invite-component/invite-component-container','tagmanager','api-access','api-access','api-access','cookie-handler','web-urls','bowser','api-access','api-access','lib/multivariate-testing/multivariate-testing','meetings/lib/start-meeting/start-meeting','popover-binder','avatar-binder','meeting-id','web-urls'],function (require, exports, module) {
    var app = require('durandal/app');
    var ko = require('knockout');
    var router = require('plugins/router');
    var _ = require('lodash');
    var Scheduler = require('../../scheduler/scheduler-container');
    var moment = require('moment');
    var i18n = require('i18next');
    var Invite = require('invite-component/invite-component-container');
    var tagmanager = require('tagmanager');
    var numbersApi = require('api-access').numbers;
    var cors = require('api-access').cors;
    var gotomeet = require('api-access').gotomeet;
    var cookieHandler = require('cookie-handler');
    var gotoMeetMeUrl = require('web-urls').get('gotoMeetMeUrl');
    var bowser = require('bowser');
    var meetingsApi = require('api-access').meetings;
    var userApi = require('api-access').user;
    var multivariateTesting = require('lib/multivariate-testing/multivariate-testing');
    var startMeeting = require('meetings/lib/start-meeting/start-meeting').startMeeting;

    require('popover-binder');
    require('avatar-binder');
    require('meeting-id');

    function meetings() {
        var self = this;

        self.router = router; // Router is used to construct .meeting-nav

        self.meetings = ko.observableArray();
        self.upcomingMeetings = ko.observableArray([]);

        self.pastMeetings = ko.observableArray();
        self.pastMeetingsVisible = ko.observable(false);

        self.me = ko.observable();
        self.isModalOpen = ko.observable(false);
        self.isProcessingAsync = ko.observable(false);
        self.useAmPm = ko.observable(i18n.t('web-technical.useAmPm'));
        self.meetingInSession = ko.observable(false);
        self.hasUpdatedNumbers = ko.observable(false);
        self.gotoMeetMeUrl = require('web-urls').get('gotomeetMeUrl');
        self.bowser = bowser;

        self.showTimeColumn = ko.observable();
        self.showInlineDate = ko.observable();
        self.showInSession = ko.observable();

        self.getMeetings = function () {
            var augmentG2mmMeetingsArray = function (meetingsResponse) {
                var extendMeeting = function (meeting, index) {
                    return gotomeet.getRoomByMeetingId(meeting.meetingId)
                        .done(function (info) {
                            meetingsResponse[index].roomId = info.roomId ? info.roomId : null;
                            meetingsResponse[index].profileId = info.profileId ? info.profileId : null;
                            meetingsResponse[index].roomUrl = (info.roomId && info.profileId) ?
                                gotoMeetMeUrl + '/' + info.profileId + '/' + info.roomId : null;
                        });
                };

                // Add Room specific info to the meetings.
                // NOTE: With high traffic we could end up DDOS'ing ourselves. API needs to be updated ASAP.
                // TODO: LOOPING OVER TO MAKE API CALLS IS NOT SCALABLE. NEEDS TO BE HANDLED IN THE API LAYER.
                var deferreds = _.map(meetingsResponse, extendMeeting);

                return $.when.apply($, deferreds);
            };

            return $.when(
                meetingsApi.forOrganizerFormatted(),
                userApi.settings(),
                multivariateTesting.checkVariation('g2mmSchedulingTest')
            )
                .then(function (meetingsResponse, settingsResponse, g2mmSchedulingTestVariation) {
                    var settings = settingsResponse[0];
                    var isG2MMSchedulingTest = g2mmSchedulingTestVariation === 'variation-a';

                    self.showTimeColumn(!isG2MMSchedulingTest);
                    self.showInlineDate(isG2MMSchedulingTest);
                    self.showInSession(isG2MMSchedulingTest);

                    // check settings API to see if it has `roomsEnabled` property
                    if (settings.roomsProvisioned && settings.roomsEnabled) {
                        self.isProcessingAsync(true);

                        augmentG2mmMeetingsArray(meetingsResponse)
                            .always(function () {
                                self.meetings(meetingsResponse);
                                self.isProcessingAsync(false);
                            });
                    } else {
                        self.meetings(meetingsResponse);
                    }
                });
        };

        self.gotomeetProfile = ko.observable(false);
        self.gotomeetMeeting = ko.observable(false);

        app.on('launch:meeting').then(function (event) {
            self.launchMeeting(event.meetingId);
        });

        app.on('gotomeet:meeting').then(function (meeting) {
            self.gotomeetMeeting(meeting);
        });

        self.computedMeetings = ko.computed(function () {
            if (self.meetings()) {
                var upcomingMeetings = [];
                var pastMeetings = [];

                var now = moment().valueOf();
                var sixtyMinutes = 3600 * 1000;

                _.forEach(self.meetings(), function (meeting) {
                    if (self.me()) {
                        meeting.owner = self.me().key === meeting.organizer.key;

                        // add 24hr start and end times, if needed
                        if (self.useAmPm() === 'false') {
                            if (meeting.timeStrings) {
                                meeting.timeStrings.meetingStartTime24 = moment(meeting.timeStrings.meetingStartTime +
                                    ' ' + meeting.timeStrings.meetingStartPeriod, 'hh:mm a').format('HH:mm');
                                meeting.timeStrings.meetingEndTime24 = moment(meeting.timeStrings.meetingEndTime + ' ' +
                                    meeting.timeStrings.meetingEndPeriod, 'hh:mm a').format('HH:mm');
                            }
                        }

                        // disable 'Meet Now' if a meeting is in session
                        if (meeting.screenSharing) {
                            self.meetingInSession(true);
                        }

                        if (self.gotomeetProfile()) {
                            if (meeting.meetingId === self.gotomeetProfile().meetingId) {
                                self.gotomeetMeeting(meeting);
                            }
                        }

                        // add edit, delete, end and share to meeting object
                        meeting.edit = self.editMeeting;
                        meeting.del = self.deleteMeeting;
                        meeting.end = self.endMeeting;
                        meeting.share = self.shareMeeting;
                        meeting.start = self.startMeeting;
                        meeting.isUpcoming = true;
                        meeting.coorganizersFormatted = [];

                        // create list coorganizers with commas
                        _.forEach(meeting.coorganizers, function (coorg) {
                            var fullName = ' ' + coorg.firstName + ' ' + coorg.lastName;
                            meeting.coorganizersFormatted.push(fullName);

                            meeting.coorganizersFormatted.join();
                        });

                        if (meeting.scheduledEndTime) {
                            var meetingEndTime = moment(meeting.scheduledEndTime).valueOf();

                            // populate upcoming and past meetings
                            if ((meetingEndTime + sixtyMinutes > now) || meeting.screenSharing) {
                                upcomingMeetings.push(meeting);
                            } else {
                                meeting.isUpcoming = false;
                                pastMeetings.push(meeting);
                            }
                        } else {
                            upcomingMeetings.push(meeting);
                        }
                    }
                });

                self.upcomingMeetings(upcomingMeetings);
                self.pastMeetings(pastMeetings);

                app.trigger('customer:new', self.upcomingMeetings());
            }
        });

        // create event to call get meetings from other VMs
        // this is useful for updating the list of meetings, without refresh
        app.on('get:meetings', function () {
            cors.clearCache();
            self.getMeetings();
        });

        self.reload = function () {
            return location.reload();
        };

        self.delegationToken = function () {
            if (self.meetingInSession()) {
                return self.meetingInSession().screenSharing.delegationToken;
            }
            return undefined;
        };

        app.on('meeting:end', function (meetingId) {
            self.endMeeting(meetingId);
        });

        self.endMeeting = function (meetingId) {
            // delegationToken is needed for ending meetings
            var delegationToken = self.delegationToken();

            meetingsApi.end(meetingId, delegationToken)
                .always(function () {
                    // always reload page due to EP delay in ending meeting
                    self.reload();
                });
        };

        self.deleteMeeting = function (meetingId) {
            // Arguments for the Durandal message box. Check the official docs for details.
            var message = '<b>' + i18n.t('delete.confirm.text') + '</b><br>' + i18n.t('delete.instruction');
            var title = i18n.t('delete.title');
            var options = [
                {text: i18n.t('action.delete'), value: 'Yes'},
                {text: i18n.t('delete.cancel'), value: 'No'}
            ];
            var autoClose = true;
            var settings = {
                buttonClass: 'btn',
                primaryButtonClass: 'btn-primary confirm-deletion',
                secondaryButtonClass: 'btn-secondary cancel-deletion'
            };

            app.showMessage(message, title, options, autoClose, settings)
                .then(function (res) {
                    if (res === 'Yes') {
                        meetingsApi.del(meetingId)
                            .then(function () {
                                var upcomingMeetings = _.filter(self.upcomingMeetings(), function (meeting) {
                                    return meeting.meetingId !== meetingId;
                                });

                                var pastMeetings = _.filter(self.pastMeetings(), function (meeting) {
                                    return meeting.meetingId !== meetingId;
                                });

                                self.upcomingMeetings(upcomingMeetings);
                                self.pastMeetings(pastMeetings);

                                app.trigger('get:meetings');
                            });
                    }
                });
        };

        self.editMeeting = function (meetingId, roomId) {
            if (self.meetings() && !self.isModalOpen()) {
                multivariateTesting.checkVariation('g2mmSchedulingTest').then(function (variation) {
                    self.isModalOpen(true);
                    Scheduler.show(meetingId, roomId, variation === 'variation-a')
                        .then(function () {
                            self.isModalOpen(false);
                        })
                        .fail(function () {
                            self.isModalOpen(false);
                        });
                });
            }
        };

        self.shareMeeting = function (meetingId) {
            // Track share button click
            tagmanager.gaEvent({
                category: 'My Meetings',
                action: 'Share Meeting Button'
            });

            if (self.meetings() && !self.isModalOpen()) {
                Invite.show(meetingId).then(function () {
                    self.isModalOpen(false);
                })
                .fail(function () {
                    self.isModalOpen(false);
                });
            }
        };

        self.isBrowserHtml5Compatible = function () {
            return bowser.chrome && bowser.version > 33;
        };

        self.startMeeting = function (meeting) {
            return startMeeting(meeting, { saMethod: 'starting_upcoming_meeting', isBrowserHtml5Compatible: self.isBrowserHtml5Compatible() });
        };

        self.inSessionFlag = ko.computed(function () {
            if (self.upcomingMeetings()) {
                _.forEach(self.upcomingMeetings(), function (data) {
                    if (data.screenSharing) {
                        self.meetingInSession(data);
                        app.trigger('meeting:in-session', data);
                    }
                });
            }
        });

        self.getMe = ko.computed(function () {
            return userApi.me()
                .then(function (data) {
                    return self.me(data);
                });
        });

        self.isMe = function (user) {
            return self.me() ? user.organizerKey === self.me().key : undefined;
        };

        self.showPastMeetings = function () {
            tagmanager.gaEvent({
                category: 'My Meetings',
                action: 'Show Past Meetings'
            });
            self.pastMeetingsVisible(true);
        };

        self.hidePastMeetings = function () {
            tagmanager.gaEvent({
                category: 'My Meetings',
                action: 'Hide Past Meetings'
            });
            self.pastMeetingsVisible(false);
        };

        self.hasUpdatedNumbers.subscribe(function (data) {
            if (data) {
                var phoneNumberBanner = {
                    id: 'phone-number-change-banner',
                    classes: 'alert-warning',
                    title: i18n.t('meetings.phonenumberchange.notices.warning.t1'),
                    message: i18n.t('meetings.phonenumberchange.notices.warning.t2',
                        '<a href="#number-change">', '</a>')
                };
                app.trigger('banner:addOne', phoneNumberBanner);
            }
        });

        self.getPhoneNumberChanges = function () {
            return numbersApi.phoneNumberChanges()
                .then(function (data) {
                    return data.length > 0 ?
                        self.hasUpdatedNumbers(true) :
                        self.hasUpdatedNumbers(false);
                });
        };

        self.activate = function () {
            var deferred = $.Deferred();
            var allCalls = $.when(
                gotomeet.getByUserKey(),
                userApi.settings(),
                self.getMeetings()
            );

            allCalls.then(function (profileResponse) {
                var profile = profileResponse[0];

                self.gotomeetProfile(profile);
                deferred.resolve();
            }, function () {
                // getByUserKey will fail as 404
                deferred.resolve();
            });

            return deferred.promise();
        };

        self.binding = function () {
            self.getPhoneNumberChanges();
        };

        self.compositionComplete = function () {
            if (window.location.href.indexOf('code=') > -1 && cookieHandler.get('start-session')) {
                var code = window.location.search.substring(1).split('&')[0].split('=')[1];
                var meetingId = window.location.search.substring(1).split('&')[1].split('=')[1];
                var event = {};
                event.code = code;
                event.meetingId = meetingId;
                cookieHandler.clear('start-session');
                app.trigger('launch:meeting', event);
            }
        };
    }

    module.exports = meetings;
});

